import { BehaviorSubject } from 'rxjs';
import { IMenu } from './models/core/menu';

export const menu$ =  new BehaviorSubject<IMenu[]>([
    {
      route: "lab",
      name: "Home",
      type: "link",
      icon: "home",
      auth: true,
      roles: ['Admin','OfficeAdmin','LabTech','ReadOnly']
    },
    {
      route: "home",
      name: "Search",
      type: "link",
      icon: "search",
      auth: true,
      roles: ['Admin','OfficeAdmin','LabTech','ReadOnly']
    },
    {
      route: "reports",
      name: "Reports",
      type: "link",
      icon: "leaderboard",
      auth: true,
      roles: ['Admin','OfficeAdmin','LabTech']
    },
    {
      route: "home",
      name: "Print Page",
      type: "print",
      icon: "printer",
      auth: true,
      roles: ['Admin','OfficeAdmin','LabTech']    
    },
    {
      route: "admin",
      name: "Administration",
      type: "link",
      icon: "settings",
      auth: true,
      roles: ['Admin','OfficeAdmin','LabTech']
    },
    {
      route: "home",
      name: "Keys",
      type: "keys",
      icon: "info",
      auth: true,
      roles: ['Admin','OfficeAdmin','LabTech','ReadOnly']
    }
    
  ]);
